import React from "react";

const RecentProjectCardCompleted = (props) => {
  return (
    <div class="recent-project-card">
      <div className="project-details-side">
        <div className="project-timeline">
          <div className="circle completed"></div>
          <div className="line completed"></div>
        </div>
        <div class="card-header">
          <div>
            <span>Project Name:</span>
            <strong>{props.projectname}</strong>
          </div>
          <span class="status completed">
            Completed-::- {props.projectcompletion}
          </span>
        </div>
        <div>
          <span>Project Size: </span>
          <strong>{props.projectsize}</strong>
        </div>
        <div>
          <span>Project Owner: </span>
          <strong>{props.projectowner}</strong>
        </div>
        <div>
          <span>Project Location: </span>
          <strong>{props.projectlocation}</strong>
        </div>
        <div>
          <span>Project Value(USD): </span>
          <strong>{props.projectvalue}</strong>
        </div>
        <div>
          <span>Project Start: </span>
          <strong>{props.projectstart}</strong>
        </div>
        <div>
          <span>Project Completion: </span>
          <strong>{props.projectcompletion}</strong>
        </div>
      </div>
      <div className="project-img-side">
        <img src={props.img} alt={props.projectname} />
      </div>
    </div>
  );
};

export default RecentProjectCardCompleted;
